import React, { useEffect, useMemo, useRef, useState } from "react";
import ImageLinks from "../../assets/Images/ImagesLink";
import Footer from "../../Footer";
import _, { map } from "lodash";
import {
  MapContainer,
  TileLayer,
  Marker,
  useMapEvents,
  useMap,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { useNavigate, useSearchParams } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  hide_loader,
  set_new_address_details,
  set_reciver_details,
  set_sender_details,
  show_loader,
} from "../../actions/app";
import api_requests from "../../resources/api_requests";
import utils from "../../resources/utils";
import constant from "../../resources/constant";
import { GpsIcon } from "../../assets/whiteLabelIcon";
import location_gif from "../../assets/location_dot.gif";
import { motion } from "framer-motion";
import { Capacitor } from "@capacitor/core";
import { Geolocation } from "@capacitor/geolocation";
import { useTranslation } from "react-i18next";

const customIcon = L.icon({
  iconUrl: location_gif,
  iconSize: [120, 120],
  iconAnchor: [61, 60],
});

let googleMapsLoaderPromise;
let googleMapsFailed = false;
window.gm_authFailure = () => {
  googleMapsFailed = true;
};

const ensureGoogleMapsLoaded = () => {
  if (window.google?.maps) {
    return Promise.resolve(true);
  }
  if (googleMapsFailed) {
    return Promise.reject(new Error("Google Maps auth failed"));
  }

  if (googleMapsLoaderPromise) {
    return googleMapsLoaderPromise;
  }

  googleMapsLoaderPromise = new Promise((resolve, reject) => {
    const existingScript = document.querySelector(
      'script[src*="maps.googleapis.com/maps/api/js"]',
    );

    if (existingScript) {
      existingScript.addEventListener("load", () => {
        if (window.google?.maps) {
          resolve(true);
        } else {
          reject(new Error("Google Maps failed to initialize"));
        }
      });
      existingScript.addEventListener("error", () =>
        reject(new Error("Google Maps failed to load")),
      );
      return;
    }

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${constant.GOOGLE_MAP_KEY}&v=3.exp&libraries=places,drawing,marker`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      if (window.google?.maps) {
        resolve(true);
      } else {
        reject(new Error("Google Maps failed to initialize"));
      }
    };
    script.onerror = () => reject(new Error("Google Maps failed to load"));
    document.head.appendChild(script);
  });

  return googleMapsLoaderPromise;
};

const SearchLocation = ({ title, search_text }) => {
  const dispatch = useDispatch();
  const { sender_details, reciver_details, new_address_details, is_loading } =
    useSelector((state) => state.app, shallowEqual);
  const map_ref = useRef(null);
  const [searchParams] = useSearchParams();
  const search_type = searchParams.get("type");
  const search_from = searchParams.get("from");
  const navigate = useNavigate();
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [address, setAddress] = useState("");
  const [address_input, set_address_input] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [mapCenter, setMapCenter] = useState([28.4595, 77.0266]);
  const [show_search_loaction, set_show_search_location] = useState(true);
  const [is_error, set_is_error] = useState(false);
  const [save_address, set_save_address] = useState();
  const [show_saved_address, set_show_saved_address] = useState(false);
  const { t } = useTranslation();

  // const [viewportHeight, setViewportHeight] = useState(
  //   typeof window !== "undefined" ? window.innerHeight : 0
  // );

  useEffect(() => {
    if (search_type != "new") {
      get_addresses();
    }
  }, []);

  useEffect(() => {
    set_current_location();
  }, [show_search_loaction]);

  // useEffect(() => {
  //   if (typeof window === "undefined") {
  //     return undefined;
  //   }

  //   const visualViewport = window.visualViewport;
  //   const updateViewport = () => {
  //     setViewportHeight(visualViewport?.height || window.innerHeight);
  //   };

  //   updateViewport();
  //   visualViewport?.addEventListener("resize", updateViewport);
  //   window.addEventListener("resize", updateViewport);

  //   return () => {
  //     visualViewport?.removeEventListener("resize", updateViewport);
  //     window.removeEventListener("resize", updateViewport);
  //   };
  // }, []);

  const handle_current_location = async () => {
    const currentLatLng = utils._retrieveData(constant.CURRENT_LAT_LNG);
    if (!_.isEmpty(currentLatLng)) {
      const { latitude, longitude } = currentLatLng;
      setMapCenter([latitude, longitude]);
      const map = map_ref;
      if (map.current) {
        map.current.setView([latitude, longitude]);
      }
    } else {
      if (Capacitor.isNativePlatform()) {
        try {
          const position = await Geolocation.getCurrentPosition({
            enableHighAccuracy: true,
            timeout: 10000,
          });
          const { latitude, longitude } = position.coords;
          setMapCenter([latitude, longitude]);
          const map = map_ref;
          if (map.current) {
            map.current.setView([latitude, longitude]);
          }
          return;
        } catch (error) {
          alert(t("loc_access_denied"));
          return;
        }
      }

      if ("permissions" in navigator) {
        navigator.permissions.query({ name: "geolocation" }).then((result) => {
          if (result.state === "granted") {
            navigator.geolocation.getCurrentPosition(async (pos) => {
              const { latitude, longitude } = pos.coords;
              setMapCenter([latitude, longitude]);
            });
          } else {
            alert(t("loc_access_denied"));
          }
        });
      }
      // if (navigator.geolocation) {
      //   console.log("this is navigator", navigator.geolocation);
      //   navigator.geolocation.getCurrentPosition(async (pos) => {
      //     const { latitude, longitude } = pos.coords;
      //     console.log("this is pos", pos);
      //     setMapCenter([latitude, longitude]);
      //   });
      //   console.log("this is pos", navigator);
      // }
    }
  };
  const set_current_location = () => {
    const currentLatLng = utils._retrieveData(constant.CURRENT_LAT_LNG);
    const current_change_location =
      search_type == "pickup"
        ? sender_details
        : search_type == "delivery"
          ? reciver_details
          : {};
    if (!_.isEmpty(current_change_location.coordinates)) {
      const { latitude, longitude } = current_change_location.coordinates;
      setMapCenter([latitude, longitude]);
      const map = map_ref;
      if (map.current) {
        map.current.setView([latitude, longitude]);
      }
    } else {
      if (!_.isEmpty(currentLatLng)) {
        const { latitude, longitude } = currentLatLng;
        setMapCenter([latitude, longitude]);
        const map = map_ref;
        if (map.current) {
          map.current.setView([latitude, longitude]);
        }
      } else {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(async (pos) => {
            const { latitude, longitude } = pos.coords;
            setMapCenter([latitude, longitude]);
          });
        }
      }
    }
  };

  const get_addresses = async () => {
    dispatch(show_loader());
    try {
      const response = await api_requests.get_saved_address({
        recent_count: 0,
        saved_count: 20,
        master_zone_id: 0,
      });
      const filtered = _.filter(response.data.saved, (item) => {
        if (search_type == "pickup") {
          return (
            _.isEmpty(item?.meta_info?.type) || item?.meta_info.type == "pickup"
          );
        } else {
          return item?.meta_info?.type == "drop";
        }
      });
      set_save_address(response.data.saved);
      dispatch(hide_loader());
    } catch (error) {
      dispatch(hide_loader());
    }
  };

  const handle_set_location_data = (is_saved = false, selectedLocation) => {
    const user_data = utils._retrieveData(constant.USER_DETIALS);

    const existingDetails =
      search_type === "new"
        ? new_address_details
        : search_type === "pickup"
          ? sender_details
          : reciver_details;
    let data = { ...existingDetails };
    if (is_saved) {
      data = {
        ...data,
        id: selectedLocation?.id,
        address_name: selectedLocation?.address_line1,
        address_line1: selectedLocation?.address_line1,
        city: selectedLocation?.city,
        state: selectedLocation?.state,
        pincode: String(selectedLocation?.pincode) || "00000",
        coordinates: {
          latitude: selectedLocation?.exact_location?.latitude,
          longitude: selectedLocation.exact_location?.longitude,
        },
        formatted_address: `${_.get(selectedLocation, "name", "")} ${
          selectedLocation.google_maps_address
        }`.trim(),
        label: selectedLocation?.label,
        name: !_.isEmpty(selectedLocation?.poc)
          ? selectedLocation?.poc[0]?.name
          : user_data?.first_name,
        mobile: !_.isEmpty(selectedLocation?.poc)
          ? selectedLocation?.poc[0]?.mobile
          : user_data?.mobile,
      };
    } else {
      const city = (
        _.find(selectedLocation?.address_components, (comp) => {
          if (_.includes(comp.types, "locality")) {
            return true;
          }
        }) || {}
      ).long_name
        ? (
            _.find(selectedLocation?.address_components, (comp) => {
              if (_.includes(comp.types, "locality")) {
                return true;
              }
            }) || {}
          ).long_name
        : "No City";

      const state = (
        _.find(selectedLocation?.address_components, (comp) => {
          if (_.includes(comp.types, "administrative_area_level_1")) {
            return true;
          }
        }) || {}
      ).long_name
        ? (
            _.find(selectedLocation?.address_components, (comp) => {
              if (_.includes(comp.types, "administrative_area_level_1")) {
                return true;
              }
            }) || {}
          ).long_name
        : "No state";

      const pincode = (
        _.find(selectedLocation?.address_components, (comp) => {
          if (_.includes(comp.types, "postal_code")) {
            return true;
          }
        }) || {}
      ).long_name
        ? (
            _.find(selectedLocation?.address_components, (comp) => {
              if (_.includes(comp.types, "postal_code")) {
                return true;
              }
            }) || {}
          ).long_name
        : "000000";
      data = {
        ...data,
        address_line1: "",
        label: "",
        address_name: selectedLocation?.name,
        city,
        state,
        pincode,
        coordinates: {
          latitude: selectedLocation?.geometry.location.lat(),
          longitude: selectedLocation.geometry.location.lng(),
        },
        formatted_address: `${_.get(selectedLocation, "name", "")} ${
          selectedLocation.formatted_address
        }`.trim(),
      };
    }

    if (search_type == "new") {
      dispatch(set_new_address_details(data));
      navigate(`/set-new-address?from=${search_from}`);
    } else if (search_type == "pickup") {
      dispatch(set_sender_details(data));
      navigate(`/set-pickup-address?from=${search_from}&is_saved=${is_saved}`);
    } else {
      dispatch(set_reciver_details(data));
      navigate(
        `/set-delivery-address?from=${search_from}&is_saved=${is_saved}`,
      );
    }
  };
  const handle_go_back = () => {
    if (search_type == "delivery") {
      navigate("/dashboard");
    } else {
      navigate(-1);
    }
  };

  const MapEventHandler = () => {
    const map = useMapEvents({
      // move: () => {
      //   setMapCenter(map.getCenter());
      // },
      moveend: () => {
        const latlng = map.getCenter();
        handle_drag({ lat: latlng?.lat, lng: latlng?.lng });
      },
    });

    return null;
  };

  const handle_drag = async ({ lat, lng }) => {
    setMapCenter([lat, lng]);
    try {
      await ensureGoogleMapsLoaded();
    } catch (error) {
      return;
    }
    if (!window.google?.maps) {
      return;
    }
    const geocoder = new window.google.maps.Geocoder();
    const latlng = new window.google.maps.LatLng(Number(lat), Number(lng));
    try {
      const address = await geocoder.geocode({ location: latlng });
      if (_.isEmpty(address.results)) {
        return;
      }

      if (address.results && address.results[0]) {
        const components = address.results[0].address_components;
        const selected_location = address.results[0];
        const findComponent = (type) =>
          _.get(
            _.find(components, (comp) => _.includes(comp.types, type)),
            "long_name",
            "Unknown",
          );
        // setAddress(findComponent("political"));
        setAddress(address.results[0].formatted_address);
        selected_location.name = findComponent("political");
        setSelectedLocation(selected_location);
      } else {
        console.log("No results found for the provided coordinates.");
      }
    } catch (error) {
      console.log(`${t("error_fetching_address")}: ${error.message}`);
    }
  };

  const LocationMarker = () => {
    const currentLatLng = utils._retrieveData(constant.CURRENT_LAT_LNG);
    if (!_.isEmpty(currentLatLng)) {
      return (
        <Marker
          position={[
            currentLatLng != undefined ? currentLatLng?.latitude : 28.4595,
            currentLatLng != undefined ? currentLatLng?.longitude : 77.0266,
          ]}
          icon={customIcon}
        />
      );
    }
  };

  const handleInputChange = async (e) => {
    const query = e.target.value;
    set_address_input(query);
    console.log("window.google?.maps", window.google?.maps);
    if (query.length > 2) {
      try {
        await ensureGoogleMapsLoaded();
      } catch (error) {
        setSuggestions([]);
        return;
      }
      // if (!window.google?.maps?.places) {
      //   setSuggestions([]);
      //   return;
      // }
      const options = {
        componentRestrictions: { country: "in" },
        strictBounds: true,
        types: ["establishment"],
      };
      const autocompleteService =
        new window.google.maps.places.AutocompleteService();
      autocompleteService.getPlacePredictions(
        { input: query, ...options },
        async (predictions) => {
          if (predictions) {
            const placesService = new window.google.maps.places.PlacesService(
              document.createElement("div"),
            );
            const detailsPromises = predictions.map((prediction) => {
              return new Promise((resolve) => {
                placesService.getDetails(
                  { placeId: prediction.place_id },
                  (placeDetails) => {
                    resolve(placeDetails);
                  },
                );
              });
            });
            const allDetails = await Promise.all(detailsPromises);
            set_is_error(false);
            setSuggestions(allDetails);
          } else {
            set_is_error(true);
            setSuggestions();
          }
        },
      );
    } else {
      setSuggestions([]);
    }
  };

  const btn_disable = useMemo(() => {
    let val = true;
    if (!_.isEmpty(selectedLocation) && !show_search_loaction) {
      val = false;
    }
    return val;
  }, [selectedLocation, show_search_loaction]);
  return (
    <div
      className="relative w-screen overflow-hidden h-[100vh]"
      // style={{ height: `${viewportHeight}px` }}
    >
      <div onClick={() => set_show_search_location(false)}>
        <MapContainer
          center={mapCenter}
          zoom={18}
          zoomControl={false}
          className="absolute inset-0 z-0 h-full w-full"
          ref={map_ref}
        >
          <MapEventHandler />
          <LocationMarker />
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -100%)",
              zIndex: 1000,
            }}
          >
            <GpsIcon />
          </div>
          <div
            style={{
              position: "absolute",
              right: 10,
              bottom: "38%",
              zIndex: 1000,
            }}
            onClick={handle_current_location}
          >
            <img src={ImageLinks.cureent_location} />
          </div>
        </MapContainer>
      </div>

      {!show_search_loaction && (
        <div className=" absolute left-6 top-6 flex w-[26px] h-[26px] p-[5px] justify-center items-center rounded-full bg-dark_gray">
          <img
            src={ImageLinks.chevron_right_white}
            className="w-[16px] h-[16px]"
            onClick={handle_go_back}
          />
        </div>
      )}
      <motion.div
        animate={{ top: show_search_loaction ? "15%" : "65%" }}
        transition={{
          type: "spring",
          // stiffness: 100,
          bounce: 0.3,
        }}
        className="absolute inset-x-0 z-10 bg-white flex flex-col px-6 rounded-tl-xl rounded-tr-xl bottom-[0px]"
      >
        {/* <div
        className={`absolute inset-0 z-10 bg-white flex flex-col px-6 rounded-tl-xl rounded-tr-xl bottom-[0px] ${
          show_search_loaction ? "top-[15%]" : "top-[65%]"
        }`}
      > */}
        <div
          className="flex pt-4 justify-center"
          onClick={() => set_show_search_location(!show_search_loaction)}
        >
          <div className="w-[25px] h-[3px] rounded-[5px] bg-dark_black"></div>
        </div>
        {show_search_loaction ? (
          <>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2" onClick={handle_go_back}>
                <img
                  src={ImageLinks.chevron_right}
                  className="w-[18px] h-[19px]"
                  onClick={handle_go_back}
                />
                <p className="font-custom text-sm font-semibold text-dark_black">
                  {search_type == "new"
                    ? t("save_new_address")
                    : search_type == "pickup"
                      ? t("pickup")
                      : t("delivery")}
                </p>
              </div>
              <img
                src={ImageLinks.map_marked}
                className="w-[24px] h-[24px]"
                onClick={() => set_show_search_location(!show_search_loaction)}
              />
            </div>

            <div className="mt-4">
              <div
                className={`flex items-center border border-secondary rounded-lg px-4 py-2 bg-white`}
                style={{ ...(is_error && { borderColor: "#BC0000" }) }}
              >
                <div className="w-[6px] h-[6px] bg-secondary rounded-[5px] mr-3"></div>
                <input
                  id="pac-input"
                  type="text"
                  placeholder={
                    search_type == "new"
                      ? t("address_loc")
                      : search_type == "pickup"
                        ? t("pickup_from")
                        : t("delivery_to")
                  }
                  autoFocus
                  className={`w-full text-gray-700 placeholder-gray-500 bg-transparent text-sm focus:outline-none`}
                  onChange={handleInputChange}
                  value={address_input}
                />
              </div>
            </div>
            {is_error && (
              <div className="mt-6 text-center px-7">
                <p className="font-custom font-semibold text-xs text-error">
                  {t("unable_to_fetch_loc")}
                </p>
              </div>
            )}
            {!_.isEmpty(suggestions) && (
              <div className="mt-4">
                {suggestions.map((location) => (
                  <div
                    key={location.place_id}
                    // onClick={() => setSelectedLocation(location)}
                    onClick={() => handle_set_location_data(false, location)}
                    className={`flex pt-3 pb-3 cursor-pointer ${
                      selectedLocation?.place_id === location.place_id
                        ? "bg-blue-100"
                        : "hover:bg-gray-100"
                    }`}
                  >
                    <img src={ImageLinks.carbon_location_filled} />
                    <div className="ml-4 flex flex-col gap-[10px]">
                      <div>
                        <p className="font-custom font-semibold text-xs text-dark_black">
                          {location?.name}
                        </p>
                        <p className="font-custom font-medium text-dark_gray text-xs">
                          {location?.formatted_address}
                        </p>
                      </div>
                      <div className="border-b border-light_gray"></div>
                    </div>
                  </div>
                ))}
              </div>
            )}
            {_.isEmpty(suggestions) && search_type != "new" && (
              <>
                {/* <div className="w-full h-[4px] flex-shrink-0 bg-light_gray mt-4"></div> */}
                <div
                  className="flex mt-[15px]flex-row gap-[8px] items-center pl-2 pt-2"
                  onClick={() => set_show_saved_address(!show_saved_address)}
                >
                  <p className="font-custom text-sm font-semibold text-dark_black ">
                    {t("saved_addresses")}{" "}
                    {`${
                      save_address?.length > 0
                        ? `(${save_address?.length})`
                        : `(0)`
                    }`}
                  </p>
                  <img
                    src={ImageLinks.chevron_right}
                    className="w-[16px] h-[16px]"
                    style={{
                      transform: show_saved_address
                        ? `rotate(90deg)`
                        : `rotate(270deg)`,
                    }}
                  />
                </div>
                {show_saved_address && (
                  <>
                    {_.isEmpty(save_address) && !is_loading ? (
                      <div className="flex justify-center p-9">
                        <p className="font-custom text-xs font-medium text-dark_gray">
                          {t("no_saved_address")}
                        </p>
                      </div>
                    ) : (
                      <div
                        className="mt-4 overflow-auto"
                        style={{
                          display: show_saved_address ? "" : "none",
                          height: `calc(100vh - 315px - env(safe-area-inset-bottom))`,
                        }}
                      >
                        {_.map(save_address, (location) => (
                          <div
                            key={location.id}
                            onClick={() =>
                              handle_set_location_data(true, location)
                            }
                            className={`flex pt-3 cursor-pointer border-b border-[#E5E5E5] pb-3`}
                          >
                            <img src={ImageLinks.carbon_location_filled} />
                            <div className="ml-4 flex flex-col gap-[10px] w-full">
                              <div>
                                <div className="flex justify-between">
                                  <p className="font-custom font-semibold text-xs text-dark_black max-w-[200px] truncate">
                                    {location?.poc
                                      ? location.poc[0]?.name
                                      : "__"}
                                  </p>
                                  {location?.label && (
                                    <p className="bg-accents h-fit w-fit rounded-[40px] text-center py-[2px] px-[14px] font-custom font-medium text-[10px] text-primary min-w-[50px]">
                                      {location.label}
                                    </p>
                                  )}
                                </div>
                                <p className="font-custom font-medium text-dark_gray text-xs">
                                  {location?.address_line1}
                                </p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </>
                )}

                {/* {!show_saved_address && (
                  <div className="w-full h-[4px] flex-shrink-0 bg-light_gray mt-4"></div>
                )} */}
              </>
            )}
          </>
        ) : (
          <>
            <div className="mt-2">
              <p className="font-custom text-sm font-semibold text-dark_black">
                {t("set_loc")}
              </p>
              <p className="font-custom text-xs	font-medium	text-gray">
                {t("drag_map")}
              </p>
            </div>
            <div className="flex items-center border border-secondary rounded-3xl px-4 py-2 bg-white mt-1">
              <div className="w-[6px] h-[6px] bg-secondary rounded-[5px] mr-3"></div>
              <input
                type="text"
                placeholder={
                  search_type == "new"
                    ? `${t("address_loc")}?`
                    : search_type == "pickup"
                      ? t("pickup_from")
                      : t("delivery_to")
                }
                className="w-full text-gray-700 placeholder-gray-500 text-sm bg-transparent focus:outline-none"
                onFocus={() => {
                  setAddress("");
                  set_show_search_location(true);
                }}
                value={address}
              />
            </div>
            <div
              className="flex gap-2 mt-2 items-center"
              onClick={() => set_show_search_location(true)}
            >
              <img src={ImageLinks.location_1} className="w-[16px] h-[16px]" />
              <p className="font-custom text-sm font-semibold text-dark_black">
                Search{" "}
                {search_type == "new"
                  ? "new"
                  : search_type == "pickup"
                    ? "pickup"
                    : "delivery"}{" "}
                location
              </p>
            </div>
            <div className="mt-4">
              <button
                type="submit"
                disabled={btn_disable}
                onClick={() =>
                  handle_set_location_data(false, selectedLocation)
                }
                className="font-custom text-base font-bold btn btn-block bg-primary text-white cursor-not-allowed rounded-[30px]"
              >
                {t("confirm_loc")}
              </button>
            </div>
          </>
        )}
        {show_search_loaction && <Footer bottom={0} />}
      </motion.div>
    </div>
  );
};

export default SearchLocation;
